// @flow

const flash = (state: any = {}, action: any) => {
  switch(action.type) {
    case 'SET_FLASH':
      return { message: action.message, msgType: action.msgType };
    case 'CLEAR_FLASH':
      return {};
    default:
      return state;
  }
}

export default flash;



// WEBPACK FOOTER //
// ./src/reducers/flash.js